import { useEffect, useState, type FormEvent } from 'react';
import { Modal } from '../../../app/components/foundation';
import type { WalletAdjustmentPayload } from '../api/users.api';

interface WalletAdjustmentDialogProps {
  open: boolean;
  direction: 'credit' | 'debit';
  submitting: boolean;
  error: string | null;
  onClose: () => void;
  onSubmit: (payload: WalletAdjustmentPayload) => Promise<void>;
}

export function WalletAdjustmentDialog({
  open,
  direction,
  submitting,
  error,
  onClose,
  onSubmit,
}: WalletAdjustmentDialogProps) {
  const [amount, setAmount] = useState('');
  const [reason, setReason] = useState('');
  const [validationError, setValidationError] = useState<string | null>(null);
  const title = direction === 'credit' ? 'افزایش موجودی' : 'کاهش موجودی';

  useEffect(() => {
    if (open) {
      setAmount('');
      setReason('');
      setValidationError(null);
    }
  }, [open, direction]);

  if (!open) return null;

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const parsedAmount = Number(amount);
    if (!Number.isInteger(parsedAmount) || parsedAmount <= 0) {
      setValidationError('مبلغ باید عدد صحیح مثبت باشد.');
      return;
    }
    if (!reason.trim()) {
      setValidationError('ذکر دلیل الزامی است.');
      return;
    }
    if (!window.confirm(`آیا ${title} به مبلغ ${parsedAmount.toLocaleString('fa-IR')} تومان انجام شود؟`)) return;
    setValidationError(null);
    await onSubmit({ amount: parsedAmount, reason: reason.trim() });
  }

  return (
    <Modal open={open} onClose={onClose} title={title} className="vania-wallet-adjustment-modal">
      <form className="vania-wallet-adjustment-form" onSubmit={handleSubmit}>
        <label>مبلغ (تومان)<input dir="ltr" type="number" min="1" step="1" value={amount} onChange={(event) => setAmount(event.target.value)} disabled={submitting} required /></label>
        <label>دلیل<textarea rows={3} value={reason} onChange={(event) => setReason(event.target.value)} disabled={submitting} required /></label>
        {(validationError || error) ? <p className="vania-user-action-error" role="alert">{validationError || error}</p> : null}
        <div className="vania-user-action-row">
          <button type="button" onClick={onClose} disabled={submitting}>انصراف</button>
          <button type="submit" disabled={submitting}>{submitting ? 'در حال ثبت…' : 'تأیید'}</button>
        </div>
      </form>
    </Modal>
  );
}
